import SectionHead from './SectionHead'

const STAGES = [
  {
    number: 1,
    title: 'Meet the Team',
    agent: 'Scout',
    text: 'text-scout',
    description:
      'Your AI teammate introduces itself, strengths and weaknesses and all. The team learns what it can and cannot do before anyone relies on it.',
  },
  {
    number: 2,
    title: 'Discovery',
    agent: 'Scout',
    text: 'text-scout',
    description:
      'Everyone writes down their biggest pain points on their own. Scout then runs a vote to pick the one workflow to work on first.',
  },
  {
    number: 3,
    title: 'Documentation',
    agent: 'Archivist',
    text: 'text-archivist',
    description:
      'Archivist reads your existing docs and asks the awkward questions. The team fills the gaps the AI would otherwise guess at.',
  },
  {
    number: 4,
    title: 'Prompt Building',
    agent: 'Builder',
    text: 'text-builder',
    description:
      'Builder turns the documentation into working instructions. You test them, break them, and edit until they hold up.',
  },
  {
    number: 5,
    title: 'Wrap-Up',
    agent: 'Scout',
    text: 'text-scout',
    description:
      'Scout returns to package the session: summary, documentation, prompts, and what to do on Monday.',
  },
]

export default function MethodologyTimeline() {
  return (
    <section className="bg-navy py-14 md:py-18">
      <div className="mktg-container">
        <SectionHead
          mark="SECT. 04"
          title="The five stages"
          note="Five stages, three agents, one result you can use."
          onDark
        />

        <ol className="max-w-3xl">
          {STAGES.map((stage) => (
            <li
              key={stage.number}
              className="card card-shadow mb-4 bg-stone flex gap-4 md:gap-6 p-5"
            >
              <span className="hl text-3xl md:text-4xl text-navy/60 tabular-nums leading-none shrink-0 w-10">
                {stage.number}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-1">
                  <h3 className="font-display text-lg md:text-xl text-navy">{stage.title}</h3>
                  <span className={`mono-label ${stage.text}`}>Led by {stage.agent}</span>
                </div>
                <p className="text-navy/70 text-sm md:text-base leading-relaxed">
                  {stage.description}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
